import { OrderbookDataItem } from 'store/orderbook/types'

export const sumAmount = (arr: OrderbookDataItem[]) => {
  return arr
    .reduce((p, n) => {
      return Number(p) + Number(n.amount)
    }, 0)
    .toFixed(18)
}
